<template>
  <div>
  
    
  <b-row >
       
    <!----- SideBar All Design List ---->
    <div class="marginmasterside">
       <sidebarSettingsComponent></sidebarSettingsComponent>
    </div>
    <!----- SideBar All Design List End ----> 

     <div class="design-container-details__main" style="width:79%">
             <b-row class="col-md-12 marginmastersidebar">
          <b-col md="12" >
            <!-- <div class="pull-right"> -->
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret >
            <template v-slot:button-content>
             <!--  <span class="cui-options icons font-1xl d-block" style="font-size: 20px;"></span> -->
              <i class="fa fa-sliders" aria-hidden="true" style="font-size:20px"></i>
            </template>
            <b-dropdown-item style="font-size: 16px;"> 
            <div>
               <router-link to="/updateProfile" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Collections" style="padding-left:30px;"> 
          <i class="fa fa-pencil"></i>&nbsp;&nbsp;&nbsp; 
        <span>Profile</span>

        </router-link>
            </div>
            <div v-if="this.user_type=='Admin' || this.user_type=='Brand_Manager' || this.user_type=='Quality_Head' || this.user_type=='Quality_Controller'" >
        <router-link to="/usersdetails" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Collections" style="padding-left:30px;"> 
          <i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp; 
        <span>Manage Users</span>

        </router-link>
        
      </div>
      <div v-if="this.user_type=='Brand_Manager' || this.user_type=='Quality_Head'">
        <router-link to="/mybranddetails" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Collections" style="padding-left:30px;"> 
          <i class="fa fa-shopping-cart" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp; 
        <span>My Brands</span>

        </router-link>
        
      </div>
      <div  style="display:none">
        <router-link to="/updateProfile" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Coll ections" style="padding-left:30px;"> 
          <i class="fa fa-users"></i>&nbsp;&nbsp;&nbsp; 
        <span>Manage Vendors</span>

        </router-link>
      </div>
      <div v-if="this.user_type=='Admin'">
        <router-link to="/manage_brands" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Coll ections" style="padding-left:30px;"> 
          <i class="fa fa-users"></i>&nbsp;&nbsp;&nbsp; 
        <span>Manage Brands</span>

        </router-link>
        
      </div>
        <div v-if="this.user_type=='Admin'">
        <router-link to="/marginmaster" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Coll ections" style="padding-left:30px;"> 
          <i class="fa fa-pie-chart" aria-hidden="true"></i>


&nbsp;&nbsp;&nbsp; 
        <span>Manage Margin Master</span>

        </router-link>
        
      </div>

            </b-dropdown-item>
            
          

           

          </b-dropdown>
        <!-- </div> -->
          </b-col>
        </b-row>
      <div class="col-md-12 ">


            <!-- code for table -->
              <b-row>
                
                <b-col md="12">
                  <b-card-body>
                    <div style="margin-top:5px">
                      <h5>Select Margin Brand</h5>
                    </div>
<template >
  <div class="accordion" role="tablist" >
    <b-card no-body class="mb-1" v-for="(brand_list,index) in brandrecord" :key="brand_list.brand_id" >
      <b-card-header header-tag="header"  v-bind:id="'collapse' + index" class="p-1" role="tab" >
        <b-button block v-b-toggle="'accordion-' + brand_list.brand_id" variant="info" style="background: #F8F8F8;" @click="getbrandmargindata(brand_list.brand_id);">{{brand_list.brand_title}}</b-button>
      </b-card-header>
      <b-collapse class="'accordion-' + brand_list.brand_id" v-bind:id="'accordion-' + brand_list.brand_id" accordion="my-accordion" role="tabpanel">
        <b-card-body>
         
          <b-card-text>
              <b-row>
                
                <b-col md="12">
                  <b-card-body>
                    <div class="float-right"> 
                      <p > <b>Total Records :<span style="color:red;">{{user_totalRows}}</span></b> </p>
                     </div>

                      <b-table class="mt-4" show-empty stacked="md" :busy="isBusy"  :items="items"  :fields="multi_fields"  :current-page="currentPage" :perPage="perPage":bordered="bordered"    :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" >
                  
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>

                    <template slot="multiplier_value" slot-scope="row">
                      
                    <form @submit.prevent="allocateCall(row.item.id,row.item.multiplier_value,row.item.brand_id,form-1)" data-vv-scope="form-1">
                      <b-row >
                        <b-col class="col-md-8">
                          <b-form-group>
                            <b-form-input type="number" name="multiplier_value" v-model="row.item.multiplier_value" v-validate="{ required: true, regex: /^(?:[1-9]\\d+|[1-9])$/}" :class="{'input': true, 'text-danger': errors.has('form-1.full_name') }">
                              
                            </b-form-input>
                            <!-- <b-input-group class="mb-3">
                              <span class="icon has-text-warning">
                                <i class="fa fa-warning" v-show="errors.has('multiplier_value')" ></i>
                              </span>
                              <span style="width:240px" v-show="errors.has('form-1.multiplier_value')" class="help text-danger">{{ errors.first('form-1.multiplier_value') }}</span>
                            </b-input-group> -->
                          </b-form-group>
                      </b-col>
                        <b-col class="col-md-2">
                          <button type="submit" class="editbtn" data-toggle="tooltip" title="Change Multiplier"   style="color: #42ba96 !important; margin-top: 6px;"> <i class="fa fa-pencil-square-o" aria-hidden="true"></i></button></b-col>
                      </b-row>
                        <div class="column">
                           
                        </div>
                      </form>
                    <!-- </b-row> -->
                   
                       
                  
                  </template>
                    
                           

                  </b-table>
                  <b-col md="6" class="my-1" v-if="user_totalRows>0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="user_totalRows"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>
             
                  <!-- <b-col md="6" class="my-1" v-if="quotation_count>0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="quotation_count"
                  :per-page="perPage"
                  class="my-0"
                ></b-pagination>
              </b-col>
                   <b-table striped hover :items="items1" :fields="fields1">
                     
                  <template slot="multiplier" slot-scope="row">
                    <form @submit.prevent="allocateCall()">
                        <b-form-input type="number" style="width:75px" v-bind:id="margin"><span>{{value}}</span></b-form-input>
                        <div class="column">
                          <button href="" class="editbtn" data-toggle="tooltip" title="save value"   style="background: #b0c4de !important;color: #000 !important;"> <i class="fa fa-pencil-square-o" aria-hidden="true"></i></button> 
                        </div>
                      </form>
                   
                       
                  
                  </template>
                     
                   </b-table> -->
                 

                  </b-card-body>
               </b-col>
            </b-row>          
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
<!-- 
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-2 variant="info">Accordion 2</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
             <b-row>
                
                <b-col md="12">
                  <b-card-body>
                    <div class="float-right"> 
                      <p > <b>Total Records :<span style="color:red;">1</span></b> </p>
                     </div>
                   <b-table striped hover :items="items1" :fields="fields1">
                      <template slot="Multiplier" slot-scope="row">
                         <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
             
                         
                  </b-button>
                    </template>
                     
                   </b-table>
                 

                  </b-card-body>
               </b-col>
            </b-row>        
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card> -->

    <!-- <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-3 variant="info">Accordion 3</b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
             <b-row>
                
                <b-col md="12">
                  <b-card-body>
                    <div class="float-right"> 
                      <p > <b>Total Records :<span style="color:red;">1</span></b> </p>
                     </div>
                   <b-table striped hover :items="items1" :fields="fields1">
                      <template slot="Multiplier" slot-scope="row">
                         <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                         
                  </b-button>
                    </template>
                     
                   </b-table>
                 

                  </b-card-body>
               </b-col>
            </b-row>        
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card> -->
  </div>
</template>
               
    

                  </b-card-body>
               </b-col>
            </b-row>          
             <!-- code for table ends -->
             
       

 
      </div>
    </div>     
      
  </b-row>    
   
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
// import Vue from 'vue'



import sidebarSettingsComponent from './_sidebarSettingsComponent.vue'

const axios = require('axios')
export default {
  name: 'Tabs',
 components: {
    sidebarSettingsComponent
  },  
  data () {
    return {
      text:'Welcome to Accordance',
      isBusy: false,  
      sampelAddModal: false,    
      customer: {},
      addAgentMaster : false,
      editAgentMaster:false,
      bordered: true,
      showSideMenu:true,
      value: 10,
      items:[],
       // , tdClass:'multiplierClass'
        multi_fields: [
        {key:'brand_id',label:'Brand Name', tdClass:'multiplierClass'},
        {key:'cat_title',label:'Category' , tdClass:'multiplierClass'} , 
           {key:'subcat_title',label:'Sub category' , tdClass:'multiplierClass'},
           {key:'multiplier_value',label:'Multiplier' , tdClass:'multiplierClass'},
           {key:'updated_date',label:'Updated Date' , tdClass:'multiplierClass'},
           ],
      result:[],
      // value:[],
     currentPage:1,
     perPage:10,
     pageOptions: [5, 10, 15],
      sortDesc: true,
      sortDirection: 'desc',
      user_type: '',
      sortBy: null,
      
       editAgentMastertoggleInfo:false,
       brandrecord: [],
      showexistingusermodel: false,
      user_list:[],
      selected_user: 0,
      selected:'',
      selected_brand_id: 0,
      selected_user: [],
      selected_user_length: 0,
      isCheckAll: false,
      user_list_msg: '',
      items_message: '',
      user_totalRows: 0,
      result: [],
      multipliervalue:0,
   }

  },
  created: function() { 
  
  // this.getCreatedUserList(); 
  // this.brandlisting();
  this.getbranddetails();
  var userdata = localStorage.getItem("userData");
  var userInfo = JSON.parse(userdata);
   this.user_type = userInfo[0].user_type;
  
  },
  
  methods: 
  {   
    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.user_totalRows = filteredItems.length
        this.currentPage = 1
      },

      /****Function for Margin Data****/
      getbrandmargindata: function(value) 
    {
      // alert(value);
      document.getElementById("overlay").style.display = "block";

      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
     

     const Obj = {
              brand_id: value
            }

        this.isBusy = true;      
        axios.post(`${CONSTANTS.API_URL}/getBrandwiseMultiplierList`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
         
          
          this.isBusy =!this.isBusy; 
          if (this.result.returnmsg === 'Successful') {
             
            this.items  = this.result.returnvalue;
            this.user_totalRows = this.result.returnvalue.length;
            // this.isBusy = false;
            
          }else {
           this.items =[];
           this.user_totalRows=0;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })

    },
    /****Function for Margin Data Ends****/


      allocateCall:function(valueid,valuem,valueb,scope){
        // alert(valueid);
        // alert(valuem);
       if(valuem>=1){
         var inputnumber=document.getElementById("margin");
         var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const updateobj={
        value:valuem,
        id:valueid,
        updated_by: userInfo[0].email_id
      }
      // console.log("Updateobj",updateobj);
       axios.post(`${CONSTANTS.API_URL}/updateMultiplierValue`,updateobj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
         // console.log("Result",this.result);
          
          // this.isBusy =!this.isBusy; 
          if (this.result.returnmsg === 'Successful') {
               this.$fire({
                text:"Multiplier Updated",
                type: "success",
                timer: 30000
                      })
               this.getbrandmargindata(valueb);
            // this.multipliervalue  = this.result.returnvalue[0].multiplier_value;
            // console.log("Multiplier",this.multipliervalue);
            
          }else {
          this.multipliervalue=0;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
       }
       else{
        // this.isBusy =!this.isBusy; 
          if (this.result.returnmsg === 'Successful') {
               this.$fire({
                text:"Multiplier Value Should Be Grater Than 0",
                type: "warning",
                timer: 30000
                      })
       }
     }
      },   
    // //Code For Add User
    // checkAll: function(){

    //             this.isCheckAll = !this.isCheckAll;
    //             this.selected_user = [];
    //             if(this.isCheckAll){ // Check all
    //               for (var key in this.user_lists) {
    //                 this.selected_user.push(this.user_list[key]);
    //                 this.selected_user_length = this.selected_user.length
    //               }
    //             }
              
    //       },
          // updateCheckall: function(){
          //   if(this.selected_user.length == this.user_list.length){
          //      this.isCheckAll = true;
          //      this.selected_user_length = this.selected_user.length;
                    
          //   }else{
          //      this.isCheckAll = false;
          //      this.selected_user_length = this.selected_user.length;
                    
          //   }
          // },
    //Code For Edit Multiplier Modal Ends

      editMultiplierModal:function(){
          this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
      },
       cancel:function() {
      this.customer = {};
      this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
    },
    

    getbranddetails: function() {
        document.getElementById("overlay").style.display = "block";
        this.isBusy = true;      
        axios.post(`${CONSTANTS.API_URL}/brandlisting`,{})
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data

          if (this.result.returnmsg === 'Successful') {
           this.brandrecord = this.result.returnvalue;
            // console.log("Brandlist",this.brandrecord);
            // this.totalRows = this.result.returnvalue.length;
            // this.isBusy = !this.isBusy;
            
          }else {
          this.brandrecord =[];
           // this.totalRows=0;
           //   this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })


  
    },



  }
};
</script>
<style>
.account-settings__content>* {
    flex-grow: 1;
}

.profile-settings {
    flex-grow: 1;
    padding: 20px 24px;
}

.profile-settings>h1 {
    font-weight: 600;
    padding: 0;
    margin: 0;
}
.profile-settings .content {
    display: flex;
}
.profile-settings .content .profile-fields-container {
    max-width: 356px;
    margin-right: 56px;
}
.profile-settings .tabular-fields {
    font-size: 14px;
    line-height: 20px;
    flex-direction: column;
}
.profile-settings .tabular-fields .field-row {
    margin-top: 20px;
    min-height: 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.profile-settings .tabular-fields .field-row>.field-label {
    color: var(--fill-grey-medium);
    min-width: 100px;
    margin: 12px 0;
}
.profile-settings .tabular-fields .field-row>.field-value {
    margin-left: 32px;
    flex-grow: 1;
}

.design-container-details__main{
 
  background-color:white;
  border-left:1px solid #d4d4d4;

}

.profile-settings .content .img.img-invalid {
    background-color: #6f4ce6;
}
.profile-settings .content .img {
    max-width: 100%;
    position: relative;
    height: 175px;
    width: 175px;
    border-radius: 4px;
    overflow: hidden;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    border: 1px solid var(--fill-grey-light2);
    padding: 5px;
}
.userclass{
  word-wrap: break-word; 
  column-width: fixed;
  max-width: 150px !important;
}
.dot {
  height: 2px !important;
  width: 2px !important;
  background-color: #f30d37;;
  border-radius: 50%;
  display: inline-block;
}
.multiplierClass{
  width: 200px !important;
}
@media (max-width: 1040px)
{
 .marginmasterside{
  display:none;
 }
}
@media (min-width: 1040px)
{
 .marginmastersidebar{
  display:none;
 }
}
@media (max-width: 766px)
{
 .multiplierClass{
  width: 100% !important;
 }
 .multiplierClass{
  float: left!important;
 }
}
</style>


